import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import { useSelector } from 'react-redux';
import { createLiteralMap } from '../../../../utils/helpers';
import { selectParsedStatus } from '../../../../selectors';
import WarningExplainations from '../ContentBlocks/WarningExplainations';

const WarningExplanation = () => {
  const parsedStatus = useSelector(selectParsedStatus);

  const contentDictionary = [
    [
      WarningExplainations.explainBlock1,
      [
        HEALTH_ENROLLMENT_STATUSES.ineligNotEnoughTime,
        HEALTH_ENROLLMENT_STATUSES.ineligTrainingOnly,
      ],
    ],
    [
      WarningExplainations.explainBlock2,
      [HEALTH_ENROLLMENT_STATUSES.ineligCharacterOfDischarge],
    ],
    [
      WarningExplainations.explainBlock3,
      [HEALTH_ENROLLMENT_STATUSES.ineligNotVerified],
    ],
    [
      WarningExplainations.explainBlock4,
      [HEALTH_ENROLLMENT_STATUSES.ineligGuardReserve],
    ],
    [
      WarningExplainations.explainBlock5,
      [HEALTH_ENROLLMENT_STATUSES.ineligCHAMPVA],
    ],
    [
      WarningExplainations.explainBlock6,
      [
        HEALTH_ENROLLMENT_STATUSES.ineligCitizens,
        HEALTH_ENROLLMENT_STATUSES.ineligFilipinoScouts,
      ],
    ],
    [WarningExplainations.explainBlock7, [HEALTH_ENROLLMENT_STATUSES.deceased]],
    [
      WarningExplainations.explainBlock8,
      [HEALTH_ENROLLMENT_STATUSES.pendingMt],
    ],
    [
      WarningExplainations.explainBlock9,
      [
        HEALTH_ENROLLMENT_STATUSES.pendingOther,
        HEALTH_ENROLLMENT_STATUSES.pendingPurpleHeart,
      ],
    ],
    [
      WarningExplainations.explainBlock11,
      [HEALTH_ENROLLMENT_STATUSES.pendingUnverified],
    ],
    [
      WarningExplainations.explainBlock10,
      [
        HEALTH_ENROLLMENT_STATUSES.rejectedIncWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedRightEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedScWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.canceledDeclined,
        HEALTH_ENROLLMENT_STATUSES.closed,
      ],
    ],
  ];

  const contentMap = createLiteralMap(contentDictionary);

  return contentMap[parsedStatus] || null;
};

export default WarningExplanation;
